import { render } from "./componRadar.vue?vue&type=template&id=342d117c&scoped=true"
import script from "./componRadar.vue?vue&type=script&lang=js"
export * from "./componRadar.vue?vue&type=script&lang=js"

import "./componRadar.vue?vue&type=style&index=0&id=342d117c&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342d117c"]])

export default __exports__